import { create } from 'zustand'

export type ActivePage = 'home' | 'theses' | 'trades' | 'data-lake' | 'models'

export interface DataSource {
  id: string
  name: string
  displayName: string
  sourceType: string
  rowCount: number | null
  dateColumn: string | null
}

interface AppState {
  dataSources: DataSource[]
  setDataSources: (ds: DataSource[]) => void

  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
  sidebarCollapsed: boolean
  setSidebarCollapsed: (collapsed: boolean) => void

  activePage: ActivePage
  setActivePage: (page: ActivePage) => void
}

const COLLAPSE_KEY = 'golf.sidebarCollapsed'

function readCollapsed(): boolean {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(COLLAPSE_KEY) === '1'
}

export const useAppStore = create<AppState>((set) => ({
  dataSources: [],
  setDataSources: (dataSources) => set({ dataSources }),

  sidebarOpen: false,
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  sidebarCollapsed: readCollapsed(),
  setSidebarCollapsed: (sidebarCollapsed) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(COLLAPSE_KEY, sidebarCollapsed ? '1' : '0')
    }
    set({ sidebarCollapsed })
  },

  activePage: 'home',
  setActivePage: (activePage) => set({ activePage }),
}))
